import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: {
    title: '',
    status: '',
    description: '',
  },
  message: {
    title: '',
    description: '',
  },
  defaultsBonus: [],
  customsBonus: [],
  allBonus: [],
};

const structureBonusSlice = createSlice({
  name: 'structureBonus',
  initialState,
  reducers: {
    GET_DEFAULTS_BONUS: state => ({
      ...state,
      isLoading: true,
    }),
    GET_DEFAULTS_BONUS_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      defaultsBonus: payload.defaultsBonus,
    }),
    GET_DEFAULTS_BONUS_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    GET_CUSTOMS_BONUS: state => ({
      ...state,
      isLoading: true,
    }),
    GET_CUSTOMS_BONUS_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      customsBonus: payload.customsBonus,
    }),
    GET_CUSTOMS_BONUS_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    GET_ALL_BONUS: state => ({
      ...state,
      isLoading: true,
    }),
    GET_ALL_BONUS_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      allBonus: payload.allBonus,
    }),
    GET_ALL_BONUS_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    UPDATE_DATA: state => ({ ...state, isLoading: true }),
    UPDATE_DATA_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      message: payload.message,
    }),
    UPDATE_DATA_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    UPDATE_BONUS: state => ({ ...state }),
    SAVE_BONUS: state => ({ ...state }),
    DELETE_BONUS: state => ({ ...state }),
    RESET_MESSAGES: state => ({
      ...state,
      message: initialState.message,
      error: initialState.error,
    }),
    RESET_STATE: () => ({ ...initialState }),
  },
});

export const {
  GET_DEFAULTS_BONUS,
  GET_DEFAULTS_BONUS_SUCCESS,
  GET_DEFAULTS_BONUS_FAIL,
  GET_CUSTOMS_BONUS,
  GET_CUSTOMS_BONUS_SUCCESS,
  GET_CUSTOMS_BONUS_FAIL,
  GET_ALL_BONUS,
  GET_ALL_BONUS_SUCCESS,
  GET_ALL_BONUS_FAIL,
  UPDATE_DATA,
  UPDATE_DATA_SUCCESS,
  UPDATE_DATA_FAIL,
  UPDATE_BONUS,
  SAVE_BONUS,
  DELETE_BONUS,
  RESET_MESSAGES,
  RESET_STATE,
} = structureBonusSlice.actions;

export const structureBonusSelector = state => state.structureBonus;

export default structureBonusSlice.reducer;
